import { get, post, getToken } from 'api/axiosApi';
import { env } from 'utils/env';
import { objToQueryString } from 'utils/functions';

const url = env.REACT_APP_LEASING_API_URL; //"http://kube-w1:32751/api";

const updateDocumentSignees = (documentId, siteId, documentSignees) => {
  return post(`${url}/leasingDocument/${documentId}/${siteId}/update-signees`, {
    documentId,
    siteId,
    documentSignees
  });
};

const getDocumentSignees = (documentId, siteId) => {
  return get(`${url}/leasingDocument/${documentId}/${siteId}/document-signees`);
};

const getDocumentEntities = (documentId, siteId) => {
  return get(`${url}/leasingDocument/${documentId}/${siteId}/document-entities`);
};

const getGuarantors = (documentId, siteId) => {
  return get(`${url}/document-partners/${documentId}/${siteId}/guarantors`);
};

const getPersons = (documentId, siteId, partnerId) => {
  return get(`${url}/leasingOffers/${documentId}/${siteId}/${partnerId}/persons`);
};

const buildExportDownloadUrl = (filePath, fileName) => {
  return `${url}/reports/documents/${encodeURIComponent(filePath)}/${encodeURIComponent(fileName)}?access_token=${getToken()}`;
};

const buildDownloadUrl = (documentId, siteId, filePath, fileName) => {
  return `${url}/leasingDocument/${documentId}/${siteId}/documents/${encodeURIComponent(filePath)}/${encodeURIComponent(
    fileName
  )}?access_token=${getToken()}`;
};

const buildDMSDownloadUrl = fileId => {
  return `${url}/leasingDocument/document/${encodeURIComponent(fileId)}/downloadFromDMS?access_token=${getToken()}`;
};

const getBulkFilesUrl = (fileName, fileIds, exportAllDocumentVersions) => {
  const urlParams = new URLSearchParams();
  fileIds.forEach(id => urlParams.append('fileIds', id));
  urlParams.append('access_token', getToken());
  urlParams.append('exportAllDocumentVersions', exportAllDocumentVersions);
  return `${url}/leasingDocument/document/${fileName}/bulk-files?${urlParams.toString()}`;
};

const dismissDocumentWorkflowError = documentWorkflowErrorId => {
  return post(`${url}/leasingDocument/dismiss-workflow-error`, {
    documentWorkflowErrorId
  });
};

const validateStateChange = (documentId, siteId, oldStateId, newStateId) =>
  get(
    `${url}/leasingDocument/validateStateChange?DocumentId=${documentId}&SiteId=${siteId}&OldStateId=${oldStateId}&NewStateId=${newStateId}`
  );

const getDocumentSecurity = (documentId, siteId) => {
  const qs = objToQueryString({ documentId, siteId });
  return get(`${url}/leasingdocument/document-security?${qs}`);
};

const exp = {
  buildExportDownloadUrl,
  buildDownloadUrl,
  buildDMSDownloadUrl,
  getBulkFilesUrl,
  getDocumentSignees,
  getDocumentEntities,
  getPersons,
  updateDocumentSignees,
  dismissDocumentWorkflowError,
  validateStateChange,
  getDocumentSecurity,
  getGuarantors
};
export default exp;
